import { Provider } from "react-redux";
import { Helmet } from "react-helmet";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";

import preview from "./assets/preview.png";

import { Routing } from "./routes";
import { store } from "./redux";

import "./i18n";
import { createTheme } from "./theme";

import "./index.css";
import "react-datasheet-grid/dist/style.css";

const router = createBrowserRouter([
	{
		path: "*",
		element: <Routing />,
	},
]);

function App() {
	return (
		<>
			<Helmet>
				<meta content={preview} property="og:image" />
				<meta
					content="Signalist | Get better qualified B2B leads with less human effort with Signalist"
					name="og:title"
				/>
				<meta
					content="Get better qualified B2B leads with less human effort with Signalist"
					name="og:description"
				/>
			</Helmet>
			<Provider store={store}>
				<ThemeProvider theme={createTheme({ colorPreset: "digitalnow" })}>
					<CssBaseline />
					<RouterProvider router={router} />
				</ThemeProvider>
			</Provider>
		</>
	);
}

export default App;
